module.exports = __webpack_public_path__ + "static/media/alternateBackgroundLessThanFour.42935111.png";